<template>
  <div class="chat_room_internet_apply_wrap">
    <div class="chat_room_internet_apply">
      <div class="a_title">인터넷 견적을 드립니다.</div>
      <div class="a_con">
        <div class="a_txt_wrap mb">
          <div class="a_txt_1">통신사</div>
          <div class="a_txt_s_4">
            {{ applyModel.telecom }}
          </div>
        </div>
        <div class="a_txt_wrap mb">
          <div class="a_txt_1">상품구성</div>
          <div class="a_txt_s_4">
            <span
              v-html="toBR(applyModel.item.replace('[TV]', '<br />[TV]'))"
            ></span>
            <span v-if="applyModel.phoneTogether == 'PHONE'">
              +휴대폰
            </span>
            <span v-else-if="applyModel.phoneTogether == 'USIM'">
              +USIM
            </span>
          </div>
        </div>
      </div>
      <div class="a_con" v-if="applyModel.promotionId > 0">
        <div class="a_txt_wrap mb">
          <div class="a_txt_1">혜택</div>
          <div class="a_txt_s_2">
            {{
              (parseInt(applyModel.cashSupport, 10) +
                parseInt(applyModel.giftCardSupport, 10) +
                parseInt(applyModel.giftItemSupport, 10) +
                parseInt(applyModel.perceSupport, 10))
                | comma
            }}원 지원
          </div>
        </div>
        <div class="a_txt_s_3">
          매장지원 {{ getNumberToKorean(applyModel.cashSupport) }}원

          <span v-if="applyModel.giftCardSupport > 0">
            (상품권{{ getNumberToKorean(applyModel.giftCardSupport) }}원 포함)
          </span>
          + 퍼스지원
          {{ getNumberToKorean(applyModel.perceSupport) }}원
        </div>
      </div>
      <div class="a_con" v-else>
        <div class="a_txt_wrap mb" v-if="applyModel.itemInternet">
          <div class="a_txt_1">요금제</div>
          <div class="a_txt_s_4">
            <div v-if="applyModel.itemInternet">
              [인터넷] {{ applyModel.itemInternet }}
            </div>
            <div v-if="applyModel.itemTv">[TV] {{ applyModel.itemTv }}</div>
          </div>
        </div>
        <div class="a_txt_wrap mb">
          <div class="a_txt_1">월 납부액</div>
          <div class="a_txt_s_2">{{ toCurrency(applyModel.monthPrice) }}원</div>
        </div>
        <div class="a_txt_wrap">
          <div class="a_txt_1">혜택</div>
          <div class="a_txt_s_2">
            {{
              (parseInt(applyModel.cashSupport, 10) +
                parseInt(applyModel.giftCardSupport, 10) +
                parseInt(applyModel.giftItemSupport, 10))
                | comma
            }}원 지원
          </div>
        </div>
        <div class="a_txt_s_3">
          (<span v-if="applyModel.cashSupport > 0"
            >{{ applyModel.cashSupport | comma }}원 현금
            <span
              v-if="
                applyModel.giftCardSupport == 0 &&
                  applyModel.giftItemSupport == 0
              "
              >지원</span
            >
          </span>
          <span v-if="applyModel.giftCardSupport > 0">
            <span v-if="applyModel.cashSupport > 0"> + </span>
            {{ applyModel.giftCardSupport | comma }}원 상품권
            <span v-if="applyModel.giftItemSupport == 0">지원</span>
          </span>
          <span v-if="applyModel.giftItemSupport > 0">
            <span
              v-if="
                applyModel.cashSupport > 0 || applyModel.giftCardSupport > 0
              "
            >
              + </span
            >{{ applyModel.giftItemSupport | comma }}원 사은품
            <span>지원</span>
          </span>
          )
        </div>
      </div>
      <div class="a_con_b" v-html="toBR(applyModel.requirement)"></div>
    </div>
    <div v-if="applyModel.icqId">
      <button
        class="btn bo"
        style="margin-bottom:0.8rem;"
        @click.stop.prevent="openApply()"
      >
        상세 보기
      </button>
      <button
        class="btn bo fw800"
        @click.stop.prevent="formApply()"
        v-if="isCustomer && applyAble"
      >
        가입신청서 작성하기
      </button>
      <button class="btn bo grey" v-if="isCustomer && !applyAble">
        기간 만료
      </button>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    applyModel: Object,
    isCustomer: Boolean,
    chatroom: Object,
    applyCreatedAt: String,
  },
  data() {
    return {
      applyAble: true,
    };
  },
  mounted() {},
  created() {
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const createdAt = new Date(this.applyCreatedAt);

    const sDays = format(
      new Date(createdAt.setDate(createdAt.getDate() + 1)),
      'yyyy-MM-dd HH:mm:ss',
    );

    if (now > sDays) {
      this.applyAble = false;
    } else {
      this.applyAble = true;
    }
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    toBR(str) {
      return util.toBR(str);
    },
    // 상세보기
    async openApply() {
      ////////////// this.applyModel.id 로 넘길것
      this.$router.push({
        // name: 'InternetCommerce.ApplyForm',
        // params: {
        //   mode: 'detail',
        //   icqId: this.applyModel.icqId,
        //   applyType: 'normal',
        //   hideView: true,
        // },
        name: 'InternetCommerce.ApplyDetail',
        params: {
          mode: 'icq_detail',
          icqId: this.applyModel.icqId,
          title: '퍼스 인터넷 견적서',
        },
      });
    },
    formApply() {
      this.$router.push({
        name: 'InternetCommerce.ApplyForm',
        params: {
          mode: 'submit',
          storeId: this.applyModel.storeId,
          icqId: this.applyModel.icqId,
        },
      });
    },
    getNumberToKorean(number) {
      return util.numberToKorean(number);
    },
  },
};
</script>

<style></style>
